import React, { Fragment } from "react";
import BusinessTablePage from "./pages/BusinessTablePage";
const App = () => {
  return (
    <Fragment>
      <BusinessTablePage />
    </Fragment>
  );
};

export default App;
